<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TcZtCy/images/cover.jpg?1697492716224" alt="This image is the cover for the book Comfort Crocheted Afghans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Comfort Crocheted Afghans
      </h1>
      <p class="bookDescription body article font2">
        <b>Brighten your home—or brighten a loved one’s day—with these clear instructions for creating three cozy, colorful afghans.</b><br/>  <br/> For many of us, afghans are the epitome of comfort. Colorful and inviting, they are a staple of the home, without which a living room or bedroom just wouldn’t feel complete. And whether you’re making one for yourself, as a housewarming gift, or to welcome a new baby into the world, the process of creating a handmade afghan can be as rewarding as the finished product. This sampler from <i>Comfort Knitting &amp; Crochet: Afghans</i> is intended for crocheters of every skill level, and brings new life to the well-loved and versatile afghan.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Norah Gaughan, Margery Winter, Berroco Design Team, Thayer Allyson Gowdy
      </h2>
      
      <p class="authorDescription body article">Norah Gaughan, author of STC&rsquo;s&#160;<I>Knitting Nature</I>&#160;and&#160;<I>Comfort Knitting &amp; Crochet: Afghans</I>, is Berroco&rsquo;s design director; her work has been published by almost all of the major yarn companies and knitting magazines in the industry. She lives in New Hampshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stewart, Tabori & Chang
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42439281